import React from 'react'
import URLS from '../../config/URLS'
import Panel from '../../ui/Panel'
import Stats from './Stats'
import Andy from './Andy.jsx'
import Beccy from './Beccy.jsx'
import Richie from './Richie.jsx'
import Stewart from './Stewart.jsx'
import History from './History.jsx'
import { Helmet } from 'react-helmet-async'
import { PublicURL } from '../../config/Site'
import { Link } from '@abw/badger-ui'
import SomeTimes from '../../utils/SomeTimes.jsx'

export const Index = () =>
  <>
    <Helmet>
      <title>LFH - About Us</title>
    </Helmet>
    <div className="about">
      <h1 className="mar-t-none mar-b">About us</h1>
      <Panel className="pad-4">
        <h2 className="intro largest mar-t-none">
          Less hassle lens hire, since 2008
        </h2>
        <h3>
          It's always been our mission to make the hiring of photographic equipment as simple, affordable and hassle-free
          as possible.
        </h3>
        <div className="text-center pad-v-2">
          <img src={PublicURL('/img/misc/book-shoot-return-repeat.svg')} className="equation" alt="lens + delivery = happiness"/>
        </div>
        <p className="mar-b-none subtext">
          Whether you've only recently picked up a camera for the first time or have been shooting since the dawning of time,
          we're here to help you. Why not  <Link to={URLS.search} className="green" text="give it a try?"/>
        </p>
        <Stats/>
      </Panel>

      <h1 className="mar-t-4 mar-b">Who we are</h1>
      <div className="grid-2 gap-2 stack-desktop">
        <SomeTimes to="2023-10-23 08:00:00">
          <Beccy/>
        </SomeTimes>
        <Andy/>
        <Richie/>
        <Stewart/>
      </div>

      <SomeTimes to="2023-10-23 08:00:00">
        <h1 className="mar-t-4 mar-b">Company history</h1>
        <History/>
      </SomeTimes>

    </div>
  </>

export default Index